import Web3 from "web3";
import { Connectors } from "use-wallet";
import { Chain } from "../types/Chain";

declare global {
  interface Window {
    ethereum: any;
  }
}

export const networkId = parseInt(process.env.REACT_APP_CHAIN_ID!.toString());

export const web3Provider: any = () => {
  // @Ethereum
  if (networkId === Chain.ethereumMainnet) {
    return process.env.REACT_APP_ETHEREUM_MAINNET_WEB3_PROVIDER?.toString();
  }
  if (networkId === Chain.ethereumRinkeby) {
    return process.env.REACT_APP_ETHEREUM_TESTNET_WEB3_PROVIDER?.toString();
  }
  // @Binance
  if (networkId === Chain.binanceMainnet) {
    return process.env.REACT_APP_BINANCE_MAINNET_WEB3_PROVIDER?.toString();
  }
  if (networkId === Chain.binanceTestnet) {
    return process.env.REACT_APP_BINANCE_TESTNET_WEB3_PROVIDER?.toString();
  }
  return '';
}

export const etherAPI = () => {
  // @Ethereum
  if (networkId === Chain.ethereumMainnet) {
    return process.env.REACT_APP_ETHEREUM_MAINNET_ETHER_API?.toString();
  }
  if (networkId === Chain.ethereumRinkeby) {
    return process.env.REACT_APP_ETHEREUM_TESTNET_ETHER_API?.toString();
  }
  // @Binance
  if (networkId === Chain.binanceMainnet) {
    return process.env.REACT_APP_BINANCE_MAINNET_ETHER_API?.toString();
  }
  if (networkId === Chain.binanceTestnet) {
    return process.env.REACT_APP_BINANCE_TESTNET_ETHER_API?.toString();
  }
  return '';
}

export const getOwnedTokens = (wallet: string, contractAddress: string) => {
  // @Binance
  let id = '';
  // @Binance
  if (networkId === Chain.binanceMainnet) {
    id = '0x38';
  }
  if (networkId === Chain.binanceTestnet) {
    id = '0x61';
  }
  return process.env.REACT_APP_MORALIS_ALL_OWNED_TOKENS_API!
    .replace('ACCOUNT', wallet)
    .replace('NFT_CONTRACT', contractAddress)
    .replace('CHAIN_ID', id).toString();
}

export const getOpenSeaLink = () => {
  // @Ethereum
  if (networkId === Chain.ethereumMainnet) {
    return process.env.REACT_APP_MAINNET_OPENSEA?.toString();
  }
  if (networkId === Chain.ethereumRinkeby) {
    return process.env.REACT_APP_TESTNET_OPENSEA?.toString();
  }
}

export function setWalletConnected(value: keyof Connectors | null) {
  localStorage.setItem('__WALLET_CONNECTED', JSON.stringify(value));
}

export function isWalletConnected(): keyof Connectors | null {
  const val = localStorage.getItem('__WALLET_CONNECTED');

  return val ? JSON.parse(val) : null;
}

export const truncateFromCenter = (value: string): string => {
  return value.substring(0, 8) + '...' + value.substring(value.length - 3, value.length);
}

export const web3 = new Web3(web3Provider());

export const sendTransaction = async (fromAddress: any, toAddress: any, encodedABI: any, wei = `0x0`, onSuccess?: Function, onError?: Function) => {
  const web3 = new Web3(window.ethereum || web3Provider());
  if (web3) {
    try {
      const gasPrice = await web3.eth.getGasPrice();
      const tx = {
        from: fromAddress,
        to: toAddress,
        gasPrice: web3.utils.toHex(gasPrice),//`0xAB5D04C00`,
        data: encodedABI,
        value: wei
      };
      return new Promise((resolve, reject) => {
        web3.eth.sendTransaction(tx)
          .on('receipt', (receipt) => {
            resolve(receipt);
            if (onSuccess) onSuccess(receipt)
          })
          .on('error', (err) => {
            reject(err);
            if (onError) onError(err)
          });
      });
    } catch (err) {
      if (onError) onError(err)
      return null;
    }
  } else {
    return null;
  }
}


export const config = {
  networkId: networkId,
  web3Provider: web3Provider,
  etherAPI: etherAPI,
  getOpenSeaLink: getOpenSeaLink,
  setWalletConnected: setWalletConnected,
  isWalletConnected: isWalletConnected,
  truncateFromCenter: truncateFromCenter
};


